module.exports = __webpack_public_path__ + "img/kerites_logo.f28da264.svg";